var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutOrangePlacardEnGeneration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,9.7L12.5,9.7v1c2.3,0.3,3.9,2.4,3.6,4.6c-0.2,1.9-1.7,3.3-3.6,3.6v1c2.8-0.3,4.9-2.9,4.6-5.7 C16.8,11.8,14.9,9.9,12.5,9.7 M11.5,9.6c-1,0.1-2,0.5-2.8,1.1l0.7,0.8c0.6-0.5,1.3-0.8,2-0.9L11.5,9.6 M8,11.6 c-0.6,0.8-1,1.7-1.1,2.8h1c0.1-0.7,0.4-1.4,0.8-2L8,11.6 M6.9,15.4c0.1,1,0.5,2,1.1,2.7l0.7-0.7c-0.5-0.6-0.7-1.3-0.8-2L6.9,15.4  M9.5,18.2l-0.7,0.7c0.8,0.6,1.7,1,2.7,1.1v-1C10.7,18.9,10.1,18.6,9.5,18.2 M12.3,12.3V15l2.3,1.4L14.2,17l-2.7-1.6v-3.1L12.3,12.3 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,0.5l6.9,6.9v13.8c0,1.3-1,2.3-2.3,2.3H5.1c-1.3,0-2.3-1-2.3-2.3V2.8c0-1.3,1-2.3,2.3-2.3H14.3 M18.9,21.2V8.6h-5.8 V2.8h-8v18.4H18.9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutOrangePlacardEnGeneration);
export default __webpack_public_path__ + "static/media/statut_orange_placard-en-generation.f6134b77.svg";
export { ForwardRef as ReactComponent };